import { getFreshToken } from './session';

// Base URL of the billing API (Redsys, email, admin, payment links, etc.).
// Prefer the build-time env var; otherwise infer from the host so production
// (served from a zcom.es domain) hits api.zcom.es instead of localhost.
const inferApiBase = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined' && /(^|\.)zcom\.es$/i.test(window.location.hostname)) {
    return 'https://api.zcom.es';
  }
  return 'http://localhost:5000';
};

export const API_BASE = inferApiBase();

// Authenticated JSON call to the billing API (sends the Supabase session).
// On failure throws an Error carrying the backend's message; err.status and
// err.detail hold the raw HTTP status and FastAPI `detail`.
export async function apiJson(path, { method = 'GET', body } = {}) {
  const token = await getFreshToken();
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  let data = null;
  try { data = await res.json(); } catch { /* empty body */ }
  if (!res.ok) {
    const detail = data?.detail;
    const err = new Error(typeof detail === 'string' ? detail : (detail?.problem || data?.error || `HTTP ${res.status}`));
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  return data;
}

// Submit a Redsys redirect form (returned by the backend) by POSTing to the gateway.
export function postRedsysForm({ url, params }) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  Object.entries(params).forEach(([k, v]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = k;
    input.value = v;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}
